import ReactGA from 'react-ga4'
import environment from 'config/environment'

const init = () => {
  if (environment.isLocal) {
    return
  }
  ReactGA.initialize(environment.googleAnalyticsTrackingCode)
}

export default {
  init,
}
